import { take, put, race, call, takeEvery, all, fork } from "redux-saga/effects";
import * as LoginStore from "./loginStore";
import { actionCreators as loginActions } from './loginStore';
import { History, Location } from "history";
import { push, replace } from "react-router-redux";
import { LoginModel } from "./LoginModels";
import * as auth from './auth';
import { actions as rrfActions } from 'react-redux-form';
import * as Notifications from '../notifications/notificationsStore'
import { localizations } from '../localization/localization';
import { RouteName } from "../routeNames";
import { fetchUnreadNotifications, fetchNewestNotification } from "../api/notificationsApi";
import { NotificationModel } from "../common/models/CommonModels";


export function* watchLoginSagas() {
  yield all([
    takeEvery(LoginStore.ActionType.ChangePassword, changePasswordFlow),
    takeEvery(LoginStore.ActionType.ChangePasswordSubmit, changePassword),
    takeEvery(LoginStore.ActionType.ResetPassword, resetPassword)
  ]);
}


function parseJwt(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
};

export function* loginFlow(history: History) {
  while (true) {
    const request = yield take(LoginStore.ActionType.LoginRequest);

    // Get login information from the request.
    const loginData: LoginModel = request.loginData;

    yield put(loginActions.loginStarted());

    // Make sure logout is not called during authorization.
    const winner = yield race({
      auth: call(authorize, loginData),
      logout: take(LoginStore.ActionType.Logout)
    });

    if (winner.auth) {
      const company_id = winner.auth.company_id;
      const role = winner.auth.role;

      yield put(LoginStore.actionCreators.setAuth({ company_id, role, token: winner.auth, userId: winner.auth.sub, passwordChangeRequired: winner.auth.password_change_required }));

      yield call(afterLoginFlow, winner, request.location);
    }
    else {
      yield put(LoginStore.actionCreators.setAuth(null));
    }
  }
}

export function* logoutFlow() {
  while (true) {
    yield take(LoginStore.ActionType.Logout);
    yield call(logout);
    yield put(loginActions.logoutSuccess());
    yield put(push("/login"));
  }
}

function* afterLoginFlow(winner: any, location: Location) {
  
  if (winner.auth.password_change_required) {
    yield put(LoginStore.actionCreators.changePassword());
  }
  else {
    localStorage.removeItem("commonFilters");

    // Put auth parameters to login success action and store them in redux state.
    yield put(LoginStore.actionCreators.loginSuccess());

    yield fork(getUnreadNotifications);

    const { from } = location.state as { from: Location }  || { from: { pathname: "/" } };
    yield put(replace(from));
  }
}

function* getUnreadNotifications() {
  const unreadNotifications = yield call(fetchNewestNotification);
  if (unreadNotifications) {
    yield all([unreadNotifications.map((item: NotificationModel) => {
      return call(addNotification, item);
    })]);
  }
}

function* addNotification(item: NotificationModel){
  if (item.id){
    yield put(Notifications.actionCreators.addNotification({id: item.id, message: item.message, variant: "info", goTo: item.redirectTo }));
  }
}

function* authorize(loginData: LoginModel) {
  try {
    const response = yield call(auth.login, loginData);

    localStorage.setItem('token', response.access_token);

    const jwt = parseJwt(response.access_token);
    return jwt;
  } catch (error) {
    yield put(loginActions.loginFailed(LoginStore.LoginError.WrongUserOrPassword))
    return null;
  }
}

function* logout() {
  try {
    const response = yield call(auth.logout);

    yield put(LoginStore.actionCreators.setAuth(null));
    localStorage.removeItem('token');

    return response;
  } catch (error) {
    return null;
  }
}

function* addNotificationPasswordChanged(){
  yield put(Notifications.actionCreators.addNotification({id: "passwordChanged", message:  localizations.validation.passwordChanged , variant: "success", autohide: true }));
}
function* addNotificationPasswordReseted(){
  yield put(Notifications.actionCreators.addNotification({id: "passwordReseted", message: localizations.validation.resetPassword, variant: "success", autohide: true }));

}
function* addNotificationPasswordChangeFailed(){
  yield put(Notifications.actionCreators.addNotification({id: "passwordChangeFailed", message: localizations.validation.passwordChangeError, variant: "error", autohide: true }));
}
function* changePasswordFlow() {
  yield put(rrfActions.reset("changePasswordModel"))
  yield put(push("/user/changePassword"));
}

function* changePassword(action: LoginStore.ChangePasswordSubmitAction) {

  // Todo: check if changing was succesful.
  const result = yield call(auth.changePassword, action.data);

  if (result) {
    yield put(LoginStore.actionCreators.changePasswordSuccess());
    yield put(rrfActions.reset("changePasswordModel"))
    yield put(push("/"))
    yield fork(addNotificationPasswordChanged);
    yield fork(getUnreadNotifications);
  }
  else{
    yield fork(addNotificationPasswordChangeFailed);
    yield changePasswordFlow()

  } 
}

function* resetPassword(action: LoginStore.ResetPasswordAction) {
  const result = yield call(auth.resetPassword, action.userName);
  if (result) {
    yield fork(addNotificationPasswordReseted);
  }
}



// WEBPACK FOOTER //
// ./src/login/loginSaga.ts